
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m55.9 38.9c2-3.5 3.1-7.5 3.1-11.8 0-13.8-12.1-25.1-27-25.1-14.9 0-27 11.3-27 25.2 0 4.2 1.1 8.2 3.1 11.8-1.9 1.3-3.1 3.5-3.1 5.9 0 4.1 3.6 7.5 8 7.5.4 0 .8 0 1.2-.1-.5 1.2-1.1 2.6-1.2 3.4-.6 3.1 2.7 5.7 6.1 5.7 0 0 1.6.1 2-.2 1.3-1.2 0-6.4 0-6.4 0-.9.8-1.6 1.7-1.6s1.7.7 1.7 1.6c0 0-1.2 5.4 0 6.6 1 .9 4.8.9 5.8 0 1.3-1.2 0-6.6 0-6.6 0-.9.8-1.6 1.7-1.6.9 0 1.7.7 1.7 1.6 0 0-1.3 5.4 0 6.6 1 .9 4.8.9 5.8 0 1.3-1.2 0-6.6 0-6.6 0-.9.8-1.6 1.7-1.6 1 0 1.7.7 1.7 1.6 0 0-1.3 5.3 0 6.4.3.3 2 .2 2 .2 3.4 0 6.7-2.6 6.1-5.7-.1-.7-.7-2.2-1.2-3.4.4.1.8.1 1.2.1 4.4 0 8-3.4 8-7.5 0-2.4-1.2-4.6-3.1-6m-38.5 1.4c-3-2.1-10.9-10.8-4.4-11.1 4-.2 13.7 3.1 14.3 6.8.5 2.6-6.8 6.4-9.9 4.3m19.1 7.9c-1.5 1.4-7.2 1.4-8.8 0-1.4-1.4.9-2.4 1.8-3.8 1-1.7 1.4-3.2 2.6-3.2 1.2 0 1.7 1.5 2.6 3.2.9 1.4 3.3 2.5 1.8 3.8m10.4-7.9c-3 2.1-10.3-1.8-9.9-4.3.6-3.7 10.3-7 14.3-6.8 6.5.4-1.4 9.1-4.4 11.1", fill: "#bab6b6" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/skull.js
// module id = 721
// module chunks = 0